<template>
  <svg :class="[bem(), className]" aria-hidden="true" @click="click">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
import { create } from '../utils'

export default create({
  name: 'icon',
  props: {
    name: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.name}`
    }
  },
  methods: {
    click() {
      this.$emit('click')
    }
  }
})
</script>

<style lang="scss" src="./index.scss"></style>
